import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { NewRouterBreadcrumbsBar } from "@legacy-megarax/ui-components";
import { useConfig } from "@megarax/dev-config";
import { MegaraxWebappContainer } from "@megarax/features";
import { BudgetPage, BudgetsHome, NewBudgetPage } from "@megarax/invoices-budgets";
import {
  AllDraftsPage,
  AllThreadsHome,
  CreateDraftPage,
  DraftPage,
  ThreadPage,
  ThreadStateContextProvider,
} from "@megarax/invoices-invoice-thread";
import { MegaraxProviders } from "@megarax/root";
import { MdRequestQuote } from "react-icons/md";
import { Navigate, Outlet, Route } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

const invoicesTheme: Theme = createTheme("234");

export const useInvoicesRouter = () => {
  return (
    <Route
      path="/invoices"
      element={
        <ThemeProvider theme={invoicesTheme}>
          <InvoicesMegaraxWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="" element={<Navigate to={getMegaraxPath.uri("megarax://invoices/threads")} replace />} />
      <Route path="drafts">
        <Route path="" element={<AllDraftsPage />} />
        <Route path="new" element={<CreateDraftPage />} />
        <Route path="id/:uuid/*" element={<DraftPage />} />
      </Route>
      <Route path="threads">
        <Route path="" element={<AllThreadsHome />} />
        <Route path="id/:uuid/*" element={<ThreadPage />} />
      </Route>
      <Route path="budgets">
        <Route path="" element={<BudgetsHome />} />
        <Route path="new" element={<NewBudgetPage />} />
        <Route path="id/:uuid" element={<BudgetPage />} />
      </Route>
    </Route>
  );
};

const InvoicesMegaraxWebappContainer: React.FC = () => {
  const { config } = useConfig();

  return (
    <MegaraxWebappContainer
      logo={<MdRequestQuote width="1em" height="1em" />}
      title="Faktury"
      subtitle="megarax.net"
      bypassAuth={config.testUser.enabled}
    >
      <ThreadStateContextProvider>
        <MegaraxProviders themeConfig="invoices">
          <NewRouterBreadcrumbsBar />
          <Outlet />
        </MegaraxProviders>
      </ThreadStateContextProvider>
    </MegaraxWebappContainer>
  );
};
